<template>

        <header class="main-header">

                <div class="header-content">
                        <div class="logo-container">
                                <router-link to="/projects">
                                        <img src="@/assets/images/header/logo.svg" :alt="$t('legacy.Логотип компании')" class="logo" />
                                </router-link>
                        </div>


                        <div class="header-right">
                                <div class="total-container" v-if="shouldShowPrice">
                                        <p class="total-amount">
                                                {{ $t('legacy.Общая стоимость:') }}
                                                <span class="amount" @click="openPriceModal">{{ totalPrice }} {{ $t('common.rubles') }}</span>
                                        </p>
                                </div>

                                <div class="icon-group">
                                        <router-link to="/personal-subscription" class="subscription-badge" :class="{ 'is-premium': isPaidUser }">
                                                <span class="subscription-label">{{ subscriptionLabel }}</span>
                                                <span v-if="isPaidUser && userCredits !== null" class="subscription-credits">{{ userCredits }}</span>
                                        </router-link>

                                        <a class="faq-container" :class="{ 'guide-highlight': currentGuidePage === 1 }"
                                                href="https://vk.me/join/YdHJQA5B8kQFJScqynqAfBj9NsJLudqXm_M=" target="_blank" rel="noopener noreferrer">
                                                <img src="@/assets/images/header/faq.svg" class="icon faq-icon" />
                                        </a>

                                        <router-link to="/personal-account" class="avatar-container"
                                                :class="{ 'guide-highlight': currentGuidePage === 2 }">
                                                <img :src="getAvatarSrc()" class="icon avatar-icon" :alt="$t('legacy.Аватар пользователя')" />
                                        </router-link>

                                        <div class="menu-dots-container" v-if="!disableSideMenu" @click="toggleSidePanel">
                                                <div class="menu-dots">
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                </div>
                                        </div>
                                </div>
                        </div>

                        <div class="dropdown-menu" v-if="isMenuOpen && isMobileView && !disableSideMenu" v-click-outside="closeMenu">
                                <div class="menu-content">
                                        <div class="menu-section avatar-section">
                                                <router-link to="/personal-account" @click="closeMenu" class="avatar-link">
                                                        <img :src="avatarSrc" :alt="$t('legacy.Аватар пользователя')" class="menu-avatar" />
                                                        <span>{{ $t('legacy.Личный кабинет') }}</span>
                                                </router-link>
                                        </div>
                                        <div class="menu-section">
                                                <router-link to="/projects" @click="closeMenu">{{ $t('legacy.Мои проекты') }}</router-link>
                                        </div>
                                        <div class="menu-section" v-if="shouldShowPrice">
                                                <p class="total-amount">
                                                        {{ $t('legacy.Общая стоимость:') }}
                                                        <span class="amount" @click="openPriceModal" style="cursor: pointer;">{{ totalPrice }} {{ $t('common.rubles') }}</span>
                                                </p>
                                        </div>
                                </div>
                        </div>
                </div>

                <div class="side-panel" :class="{ 'side-panel-open': isSidePanelOpen && !disableSideMenu }" v-click-outside="closeSidePanel" v-if="!disableSideMenu">
                        <div class="side-panel-content">
                                <div class="side-panel-header">
                                        <router-link to="/personal-account" class="avatar-container"
                                                :class="{ 'guide-highlight': currentGuidePage === 2 }">
                                                <img :src="avatarSrc" style="width: 40px; height: 40px;" class="icon avatar-icon"
                                                        :alt="$t('legacy.Аватар пользователя')" />
                                        </router-link>

                                        <img src="@/assets/images/header/x.svg" class="close-icon" @click="closeSidePanel" />
                                </div>

                                <div class="side-panel-menu">
                                        <ul class="side-nav-list">
                                                <li class="nav-item">
                                                        <router-link to="/projects">{{ $t('legacy.Мои проекты') }}</router-link>
                                                </li>
                                        </ul>
                                </div>

                                <div class="side-panel-section" v-if="shouldShowPrice">
                                        <p class="total-amount">
                                                {{ $t('legacy.Общая стоимость:') }}
                                                <span class="amount">{{ totalPrice }} {{ $t('common.rubles') }}</span>
                                        </p>
                                </div>

                                <div class="logo-container">
                                        <img src="@/assets/images/header/logo.svg" :alt="$t('legacy.Логотип компании')" class="logo" />
                                </div>
                        </div>
                </div>






                <AppPriceDetailsModal v-if="isPriceModalOpen" :items="droppedImages" @close="closePriceModal" />
        </header>
</template>

<script>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import AppPriceDetailsModal from './AppPriceDetailsModal.vue'
import { useI18n } from '@/i18n'
export default {
        components: { AppPriceDetailsModal },
        props: {
                droppedImages: {
                        type: Array,
                        default: () => []
                },
                onOpenGuide: Function,
                currentPage: {
                        type: Number,
                        default: 0
                },
                disableSideMenu: {
                        type: Boolean,
                        default: false
                }
        },
        setup(props, { emit }) {
                const store = useStore()
                const { t, locale } = useI18n()
                const router = useRouter()
                const route = useRoute()
                const isSidePanelOpen = ref(false)
                const isMobileView = ref(window.innerWidth <= 1024)
                const isMenuOpen = ref(false)
                const user = computed(() => store.state.auth.user)
                const avatarSrc = computed(() => store.getters['ui/avatarSrc'])
                const getAvatarSrc = () => {
      if (user.value?.avatar) {
        return `${user.value.avatar}?t=${Date.now()}`;
      }

      return require('@/assets/images/header/avatar.jpg');
                }

                const totalPrice = computed(() => store.getters['zones/totalProjectPrice'] || 0)
                const currentGuidePage = computed(() => props.currentPage ?? 0)
                const canSeePrices = computed(() => store.getters['subscription/canSeePrices'])
                const shouldShowPrice = computed(() => route.path.startsWith('/category/') && canSeePrices.value)
                const isPaidUser = computed(() => store.getters['subscription/isPaid'])
                const isBaseUser = computed(() => store.getters['subscription/isBase'])
                const isPremiumUser = computed(() => store.getters['subscription/isPremium'])
                const subscriptionLabel = computed(() => {
                        locale.value
                        if (isPremiumUser.value) return t('subscription.premium')
                        if (isBaseUser.value) return t('subscription.base')
                        return t('subscription.free')
                })
                const userCredits = ref(null)

                const loadCredits = async () => {
                        if (isPaidUser.value) {
                                try {
                                        const { getCredits } = await import('@/api/credits.js')
                                        const result = await getCredits()
                                        userCredits.value = result.credits || 0
                                } catch (error) {
                                        console.error('Error loading credits:', error)
                                        userCredits.value = 0
                                }
                        }
                }

                const isPriceModalOpen = ref(false)

                const openPriceModal = () => {
                        isPriceModalOpen.value = true
                        emit('price-modal-opened', true)
                }

                const closePriceModal = () => {
                        isPriceModalOpen.value = false
                        emit('price-modal-opened', false)
                }

                const toggleSidePanel = () => {
                        if (isMobileView.value) {
                                isMenuOpen.value = !isMenuOpen.value
                        } else {
                                isSidePanelOpen.value = !isSidePanelOpen.value
                        }
                }

                const closeSidePanel = () => {
                        isSidePanelOpen.value = false
                }

                const closeMenu = () => {
                        isMenuOpen.value = false
                }

                const handleResize = () => {
                        isMobileView.value = window.innerWidth <= 1024
                }

                const openGuide = (guideNumber) => {
                        if (props.onOpenGuide) {
                                emit('open-guide', guideNumber)
                        } else {
                                router.push('/projects')
                        }
                }

                const closeGuide = () => {
                        // Убираем локальное управление
                        emit('close-guide')
                }

                const handleClickOutside = (event) => {
                        if (
                                !event.target.closest('.faq-container') &&
                                !event.target.closest('.avatar-container') &&
                                !event.target.closest('.guide-container')
                        ) {
                                closeGuide()
                        }
                }

                const handleLogout = async () => {
                        await store.dispatch('auth/logout')
                        router.push('/login')
                }

                const handleDownloadClick = () => {
                        emit('download-image')
                }

                watch(isPaidUser, (newVal) => {
                        if (newVal && userCredits.value === null) {
                                loadCredits()
                        }
                }, { immediate: true })

                onMounted(() => {
                        document.addEventListener('click', handleClickOutside)
                        window.addEventListener('resize', handleResize)
                })

                onUnmounted(() => {
                        document.removeEventListener('click', handleClickOutside)
                        window.removeEventListener('resize', handleResize)
                })

                return {
                        getAvatarSrc,
                        avatarSrc,
                        totalPrice,
                        currentGuidePage,
                        shouldShowPrice,
                        openGuide,
                        closeGuide,
                        isSidePanelOpen,
                        toggleSidePanel,
                        closeSidePanel,
                        closeMenu,
                        isMobileView,
                        isMenuOpen,
                        isPriceModalOpen,
                        openPriceModal,
                        closePriceModal,
                        handleLogout,
                        handleDownloadClick,
                        isPaidUser,
                        subscriptionLabel,
                        userCredits
                }
        }
}
</script>


<style scoped>
.main-header {
        background: linear-gradient(to right, #ffffff, #c2cfdc, #c2cfdc);
        border: 1px solid #fafafa;
        border-radius: 10px;
        padding: 10px 20px;
        margin: 15px;
        font-family: 'Montserrat';
        box-shadow: 0 2px 8px rgba(38, 55, 78, 0.15);
}

.header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
}

.logo {
        width: 100px;
        padding-top: 6px;
        height: auto;
}

.header-left {
        display: flex;
        align-items: center;
}

.header-right {
        display: flex;
        align-items: center;
        gap: 20px;
}

.nav-list {
        display: flex;
        gap: 32px;
        list-style: none;
        margin: 0;
        padding: 0;
}

.link-button {
        color: #496782;
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        text-decoration: none;
        transition: opacity 0.3s;
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
}

.link-button:hover {
        opacity: 0.8;
}

.nav-item a {
        color: #496782;
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        text-decoration: none;
        transition: opacity 0.3s;
}

.nav-item a:hover {
        opacity: 0.8;
}

.total-container {
        display: flex;
        align-items: center;
}

.total-amount {
        color: #26374e;
        font-weight: 500;
        font-size: 16px;
        margin: 0;
}

.amount {
        font-weight: 700;
        font-size: 20px;
        cursor: pointer;
}

.icon-group {
        display: flex;
        gap: 12px;
        align-items: center;
}

.subscription-badge {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 0 12px;
        height: 32px;
        background: #f5f5f5;
        border-radius: 16px;
        text-decoration: none;
        font-size: 12px;
        font-weight: 600;
        color: #666;
        transition: all 0.2s;
        cursor: pointer;
}

.subscription-badge:hover {
        background: #eee;
}

.subscription-badge.is-premium {
        background: linear-gradient(135deg, #ffd700, #ffb800);
        color: #5c4a00;
}

.subscription-badge.is-premium:hover {
        background: linear-gradient(135deg, #ffe44d, #ffc31a);
}

.subscription-label {
        white-space: nowrap;
}

.subscription-credits {
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.6);
        border-radius: 10px;
        padding: 2px 8px;
        font-size: 11px;
        font-weight: 600;
        min-width: 20px;
}

.icon {
        width: 24px;
        height: 24px;
        cursor: pointer;
        transition: transform 0.3s;
}

.icon:hover {
        transform: scale(1.1);
}

.avatar-icon {
        border-radius: 50%;
        width: 100%;
        height: 100%;
        object-fit: cover;
}

.faq-container,
.avatar-container {
        position: relative;
        display: flex;
        align-items: center;
        width: 32px;
        height: 32px;
        justify-content: center;
        background-color: #faf9f7;
        border-radius: 50%;
        overflow: clip;
}

.side-panel-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
}

.close-icon {
        width: 24px;
        height: 24px;
        cursor: pointer;
        transition: transform 0.3s ease;
}

.close-icon:hover {
        transform: rotate(90deg);
}

.side-panel-menu {
        margin-left: 0;
        padding-left: 0;
        margin-bottom: 25px;
}

.side-nav-list {
        display: flex;
        flex-direction: column;
        gap: 15px;
        list-style: none;
        padding: 0;
        margin: 0;
}

.side-nav-list .nav-item a {
        color: #496782;
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        text-decoration: none;
        transition: opacity 0.3s;
}


/* Стили для меню с тремя точками */
.menu-dots-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #f0f4f8;
        cursor: pointer;
        transition: background-color 0.3s;
}

.menu-dots-container:hover {
        background-color: #e0e8f0;
}

.menu-dots {
        display: flex;
        gap: 2.1px;
        justify-content: space-between;
        align-items: center;
        height: 10px;
}

.menu-dots span {
        display: block;
        width: 3px;
        height: 3px;
        background-color: #999999;
        border-radius: 50%;
}

/* Выпадающее меню */
.dropdown-menu {
        position: absolute;
        right: 45px;
        top: 70px;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        padding: 15px;
        z-index: 1000;
        min-width: 200px;
}

.menu-content {
        display: flex;
        flex-direction: column;
        gap: 15px;
}

.menu-section {
        display: flex;
        flex-direction: column;
        gap: 10px;
}

.menu-section.avatar-section {
        border-bottom: 1px solid #e0e8f0;
        padding-bottom: 15px;
}

.avatar-link {
        display: flex;
        align-items: center;
        gap: 12px;
        color: #496782;
        text-decoration: none;
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        padding: 8px;
        border-radius: 8px;
        transition: background-color 0.3s ease;
}

.avatar-link:hover {
        background-color: #f0f4f8;
}

.menu-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid #e0e8f0;
}

.menu-section a {
        color: #496782;
        text-decoration: none;
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
}

.menu-section a:hover {
        opacity: 0.8;
}

/* Стили для боковой панели */
.side-panel {
        position: fixed;
        top: 0;
        right: -300px;
        width: 300px;
        height: 100%;
        z-index: 1000000;
        background: linear-gradient(to right, #FFFFFF, #FFFFFF, #C2CFDC, #C2CFDC);
        box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
        transition: right 0.3s ease;
        overflow-y: auto;
        padding: 20px;
}

.side-panel-open {
        right: 0;
}

.side-panel-content {
        padding: 20px;
}

.side-panel-section {
        margin-bottom: 25px;
}

.side-panel-title {
        color: #26374e;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
        text-transform: uppercase;
}

.side-panel-item {
        color: #496782;
        font-size: 14px;
        padding: 8px 0;
        cursor: pointer;
        transition: color 0.2s;
}


.side-panel-item:hover {
        color: #2a4a6b;
}

.guide-highlight {
        position: relative;
        z-index: 100001;
        animation: pulse 1.5s infinite;
}

@keyframes pulse {
        0% {
                box-shadow: 0 0 0 0 rgba(74, 144, 226, 0.7);
        }

        70% {
                box-shadow: 0 0 0 10px rgba(74, 144, 226, 0);
        }

        100% {
                box-shadow: 0 0 0 0 rgba(74, 144, 226, 0);
        }
}

/* Адаптивность */
@media (max-width: 768px) {
        .main-header {
                margin: 15px;
        }

        .header-content {
                padding: 0;
        }

        .logo {
                width: 100px;
        }


        .header-left {
                display: none;
        }

        .total-container {
                display: none;
        }

        .menu-dots-container {
                display: none;
        }

        .dropdown-menu {
                right: 20px;
                top: 65px;
        }
}

@media (min-width: 769px) {
        .menu-dots-container {
                display: none;
        }

        .header-left {
                display: flex;
        }

        .total-container {
                display: flex;
        }
}
</style>